export enum Roles {
  PlexSecurityAdmin = "FA9393BC-F94C-4304-A945-DB54EEC9F7CA",
  PlexLocalizationManager = "00F24D40-1E50-4804-96C1-62E0A974B150",
  PlexReleaseManager = "A97721CA-2921-4B5E-9F83-B5356875D32B",
  PlexTechnicalWriter = "7E046E5D-2D44-40C5-86B1-EF19DB1907B3",
  Translator = "93EF3B35-D109-4565-82B2-C599316EBADB",
  SecurityAdmin = "BE2266F8-9A06-4406-8EBE-C68A78965E54",
  LocalizationManager = "A7F381FB-EA0D-4092-B64E-5500ECA832CE"
}

export enum Tenants {
  Plex = "99A43DEF-4E2D-4703-99EC-4BAF34EA5509"
}
